import React from 'react'
import { type Column } from './utils'

interface OrganizationsTableSkeletonProps {
    visibleColumns: Column[]
    rowCount: number
}

export const OrganizationsTableSkeleton: React.FC<OrganizationsTableSkeletonProps> = ({
    visibleColumns,
    rowCount,
}) => {
    return (
        <>
            {Array.from({ length: rowCount }).map((_, index) => (
                <tr key={index}>
                    {visibleColumns.map((column) => (
                        <td key={column.key} className="px-6 py-4 whitespace-nowrap">
                            <div className="animate-pulse">
                                <div className="h-4 bg-secondary/20 rounded w-full"></div>
                            </div>
                        </td>
                    ))}
                </tr>
            ))}
        </>
    )
}

